import { useDispatch, useSelector } from 'react-redux';
import { MgState } from '@types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { registerRoute } from '@actions/appActions';
import { AuthPaths, Paths } from '@constants/paths';

const PrivateRoute = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector<MgState, boolean>(({ auth }) => auth.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn) {
      dispatch(registerRoute(pathname));
      navigate(`${Paths.AUTH}/${AuthPaths.TEST_LOGIN}`);
    }
  }, [isLoggedIn]);

  return <>{isLoggedIn ? children : ''}</>;
};

export { PrivateRoute };
